interface ProgressBarProps {
  current: number;
  total: number;
  currentQuestionNumber: number; // 1-based question number
  answers: Record<number, string>;
}

export function ProgressBar({ currentQuestionNumber }: ProgressBarProps) {
  const groups = [
    { num: 1, start: 1, end: 5, size: 5, label: "Group 1 (Q1-5)" },
    { num: 2, start: 6, end: 11, size: 6, label: "Group 2 (Q6-11)" },
    { num: 3, start: 12, end: 17, size: 6, label: "Group 3 (Q12-17)" },
    { num: 4, start: 18, end: 23, size: 6, label: "Group 4 (Q18-23)" },
  ];

  const getCurrentGroup = (questionNum: number) => {
    return (
      groups.find((g) => questionNum >= g.start && questionNum <= g.end) ||
      groups[0]
    );
  };

  const currentGroup = getCurrentGroup(currentQuestionNumber);

  const getGroupPercentage = (group: (typeof groups)[0]) => {
    if (currentQuestionNumber < group.start) return 0;
    if (currentQuestionNumber > group.end) return 100;
    // Current group: position within the group
    const positionInGroup = currentQuestionNumber - group.start + 1;
    return (positionInGroup / group.size) * 100;
  };

  return (
    <div className="w-full flex gap-4">
      {groups.map((group) => {
        const percentage = getGroupPercentage(group);
        const isCurrentGroup = group.num === currentGroup.num;

        return (
          <div key={group.num} className="flex-1">
            <div className="flex justify-between mb-1">
              <span
                className={`text-sm font-[Roboto] ${isCurrentGroup ? "text-[#ffffff] font-semibold" : "text-[#ffffff] opacity-70"}`}
              >
                {Math.round(percentage)}%
              </span>
            </div>
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full transition-all duration-300 bg-[#ff00d2]"
                style={{ width: `${percentage}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
